module.exports = __webpack_public_path__ + "static/media/man giving.d523e0fc.gif";